import React from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';

export default function Stat({ value, label, note, hasNoData }) {
  const zeroValue =
    value === 0 ||
    value === '0' ||
    value === 0.0 ||
    value === '0.0' ||
    value === '0.0%' ||
    value === '0:0' ||
    value === '0%';

  return (
    <div className={classes.Stat}>
      <div
        className={classNames(classes.value, {
          [classes.hasData]: !hasNoData && !zeroValue,
        })}
      >
        {hasNoData || zeroValue ? '-' : value}
      </div>
      <div className={classes.label}>
        {label} {note && <span className={classes.note}>({note})</span>}
      </div>
    </div>
  );
}
